import { render } from "./Certificate.vue?vue&type=template&id=78e8fa02"
import script from "./Certificate.vue?vue&type=script&lang=js"
export * from "./Certificate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Samson5\\Scripts\\CVue-Awesome\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__